import * as React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

export const SlackIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        {...props}
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.42763 18.8974C6.42763 20.6218 5.03393 22.0155 3.30952 22.0155C1.58511 22.0155 0.191406 20.6218 0.191406 18.8974C0.191406 17.173 1.58511 15.7793 3.30952 15.7793H6.42763V18.8974ZM7.98668 18.8974C7.98668 17.173 9.38038 15.7793 11.1048 15.7793C12.8292 15.7793 14.2229 17.173 14.2229 18.8974V26.6927C14.2229 28.4171 12.8292 29.8108 11.1048 29.8108C9.38038 29.8108 7.98668 28.4171 7.98668 26.6927V18.8974Z"
          fill="#E01E5A"
        />
        <path
          d="M11.105 6.37782C9.38057 6.37782 7.98687 4.98412 7.98687 3.25971C7.98687 1.5353 9.38057 0.141602 11.105 0.141602C12.8294 0.141602 14.2231 1.5353 14.2231 3.25971V6.37782H11.105ZM11.105 7.9605C12.8294 7.9605 14.2231 9.3542 14.2231 11.0786C14.2231 12.803 12.8294 14.1967 11.105 14.1967H3.28608C1.56167 14.1967 0.167969 12.803 0.167969 11.0786C0.167969 9.3542 1.56167 7.9605 3.28608 7.9605H11.105Z"
          fill="#36C5F0"
        />
        <path
          d="M23.6 11.0786C23.6 9.3542 24.9937 7.9605 26.7181 7.9605C28.4425 7.9605 29.8362 9.3542 29.8362 11.0786C29.8362 12.803 28.4425 14.1967 26.7181 14.1967H23.6V11.0786ZM22.0409 11.0786C22.0409 12.803 20.6472 14.1967 18.9228 14.1967C17.1984 14.1967 15.8047 12.803 15.8047 11.0786V3.25971C15.8047 1.5353 17.1984 0.141602 18.9228 0.141602C20.6472 0.141602 22.0409 1.5353 22.0409 3.25971V11.0786Z"
          fill="#2EB67D"
        />
        <path
          d="M18.9228 23.5746C20.6472 23.5746 22.0409 24.9683 22.0409 26.6927C22.0409 28.4171 20.6472 29.8108 18.9228 29.8108C17.1984 29.8108 15.8047 28.4171 15.8047 26.6927V23.5746H18.9228ZM18.9228 22.0155C17.1984 22.0155 15.8047 20.6218 15.8047 18.8974C15.8047 17.173 17.1984 15.7793 18.9228 15.7793H26.7417C28.4661 15.7793 29.8598 17.173 29.8598 18.8974C29.8598 20.6218 28.4661 22.0155 26.7417 22.0155H18.9228Z"
          fill="#ECB22E"
        />
      </svg>
    </SvgIcon>
  );
};
